import Image from 'next/image';
import React from 'react';

function Bio({ showFitmentDisclaimer, imageUrl, name, quote }) {
	return (
		<div className="bio">
			<div className="bio-details item">
				<div className="thumb-container">
					<Image objectFit="contain" width="100px" height="100px" src={imageUrl} alt="bio" />
				</div>

				<div className="text-container">
					<h4>
						Meet your Installation Tech, <span>{name}</span>
					</h4>
					<blockquote>
						<i className="fas fa-quote-left"></i>
						<p>
							<Image objectFit="contain" width="100px" height="100px" src={imageUrl} alt="bio" />
							{quote}
						</p>
					</blockquote>
					<p className="disclaimer">
						Behind every installation is a person, we promote both independent and small businesses in your
						local community. Local For Local.
					</p>
				</div>
			</div>

			{showFitmentDisclaimer && (
				<div className="fitment-guarantee item">
					<div className="icon-container">
						<i className="fas fa-check-circle"></i>
					</div>
					<div className="text-container">
						<h4>Fitment Guarantee</h4>

						<p>
							If there is any issue or question with product selection we will correct at time of
							delivery!
						</p>

						<p>Additional Fees may apply at that time.</p>
					</div>
				</div>
			)}
		</div>
	);
}

export default Bio;
